 <template>
  <div class="box4">
    <pageTitle title="院校介绍"/>
    <div class="text text1">美国伊利诺伊理工大学(简称IIT)始创于1890年，位于美国第三大城市芝加哥市区，是一所世界知名的综合性私立大学。该院校被U.S.  News和QS等权威机构评为美国百强大学，与麻省理工、加州理工、卡内基梅隆大学等22所高校同为独立科技大学联盟的核心创始成员。经过130多年的发展，学校先后涌现出4位诺贝尔奖得主和评审，在全球具有极佳的学术影响力与认可度。</div>
    <div class="text text2">伊利诺伊理工大学作为芝加哥地区唯一以技术为中心的大学，被誉为芝加哥的“人才管道”，为这座城市中快速增长的科技行业源源不断地输送优质人才；其毕业生在企业间拥有极高的雇主认可度，学校培养的毕业生成为公司总裁、副总裁或经理人数比例位居全美前15名。</div>
    <div class="main-box">
      <div class="main-item" v-for="(item, index) in items" :key="index">
        <div class="item-title">{{item.title}}</div>
        <div class="item-text">{{item.text}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  mounted() {},
  data() {
    return {
      items: [
        {
          title: "16",
          text: "全美最佳管理学项目",
        }, 
        {
          title: "10",
          text: "全美最佳理工大学",
        },
        {
          title: "36",
          text: "全美最佳价值大学",
        },
        {
          title: "42",
          text: "世界大学教育质量",
        },
      ]
    };
  },
  
};
</script>

<style lang="less" scoped>
.box4 {
  padding: 80px 0;
  width:100%;
  background: url("../../../assets/coursePage/illinois/box4/bg.png") no-repeat;
  background-size: cover;
  /deep/.course-title-box .course-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 44px;
    color: #272020;
    line-height: 64px;
    text-align: center;
  }
  .text {
    padding: 0 40px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 28px;
    color: #231D1D;
    line-height: 44px;
    text-align: justify;
  }
  .text1 {
    margin-top: 48px;
  }
  .text2 {
    margin-top: 8px;
  }
  .main-box {
    margin: 32px 0 0 76px;
    width: 582px;
    height: 392px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .main-item {
      width: 252px;
      text-align: center;
      .item-title {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 96px;
        color: #CC0001;
        line-height: 116px;
      }
      .item-text {
        margin-top: 16px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 28px;
        color: #231D1D;
        line-height: 44px;
      }
    }
    .main-item:nth-child(3), .main-item:nth-child(4) {
      margin-top: 40px;
    }
  }
}
</style>
